// extracted by mini-css-extract-plugin
export default {"container":"MapImageItem_container__jg0AD","name":"MapImageItem_name__t1Nz9","round":"MapImageItem_round__paBTX"};